export const isSidebarExpandedSelector = (state) => state.layout.sidebarExpanded;

export const expandedSidebarChildItemsSelector = (state) => state.layout.expandedSidebarChildItems;
